var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundTrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258,
    height: 57.851,
    viewBox: "0 0 258 57.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(-18209 14591.878)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1361",
    "data-name": "Line 1361",
    y2: 37.803,
    transform: "translate(18234.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1372",
    "data-name": "Line 1372",
    y2: 37.803,
    transform: "translate(18289.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1381",
    "data-name": "Line 1381",
    y2: 37.803,
    transform: "translate(18343.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1390",
    "data-name": "Line 1390",
    y2: 37.803,
    transform: "translate(18398.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1362",
    "data-name": "Line 1362",
    y2: 26.684,
    transform: "translate(18222.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1370",
    "data-name": "Line 1370",
    y2: 26.684,
    transform: "translate(18277.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1379",
    "data-name": "Line 1379",
    y2: 26.684,
    transform: "translate(18331.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1388",
    "data-name": "Line 1388",
    y2: 26.684,
    transform: "translate(18386.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1363",
    "data-name": "Line 1363",
    y2: 26.684,
    transform: "translate(18258.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1376",
    "data-name": "Line 1376",
    y2: 26.684,
    transform: "translate(18313.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1385",
    "data-name": "Line 1385",
    y2: 26.684,
    transform: "translate(18368.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1394",
    "data-name": "Line 1394",
    y2: 26.684,
    transform: "translate(18422.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1397",
    "data-name": "Line 1397",
    y2: 26.684,
    transform: "translate(18440.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1400",
    "data-name": "Line 1400",
    y2: 26.684,
    transform: "translate(18458.5 -14574.813)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1364",
    "data-name": "Line 1364",
    y2: 37.803,
    transform: "translate(18246.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1373",
    "data-name": "Line 1373",
    y2: 37.803,
    transform: "translate(18301.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1383",
    "data-name": "Line 1383",
    y2: 37.803,
    transform: "translate(18355.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1392",
    "data-name": "Line 1392",
    y2: 37.803,
    transform: "translate(18410.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1360",
    "data-name": "Line 1360",
    y2: 37.803,
    transform: "translate(18216.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1369",
    "data-name": "Line 1369",
    y2: 37.803,
    transform: "translate(18270.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1378",
    "data-name": "Line 1378",
    y2: 37.803,
    transform: "translate(18325.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1386",
    "data-name": "Line 1386",
    y2: 37.803,
    transform: "translate(18374.5 -14581.483)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1365",
    "data-name": "Line 1365",
    y2: 54.851,
    transform: "translate(18240.5 -14590.378)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1374",
    "data-name": "Line 1374",
    y2: 54.851,
    transform: "translate(18295.5 -14590.378)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1382",
    "data-name": "Line 1382",
    y2: 54.851,
    transform: "translate(18349.5 -14590.378)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1391",
    "data-name": "Line 1391",
    y2: 54.851,
    transform: "translate(18404.5 -14590.378)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1366",
    "data-name": "Line 1366",
    y2: 18.531,
    transform: "translate(18228.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1371",
    "data-name": "Line 1371",
    y2: 18.531,
    transform: "translate(18283.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1380",
    "data-name": "Line 1380",
    y2: 18.531,
    transform: "translate(18337.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1389",
    "data-name": "Line 1389",
    y2: 18.531,
    transform: "translate(18392.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1368",
    "data-name": "Line 1368",
    y2: 18.531,
    transform: "translate(18264.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1377",
    "data-name": "Line 1377",
    y2: 18.531,
    transform: "translate(18319.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1387",
    "data-name": "Line 1387",
    y2: 18.531,
    transform: "translate(18380.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1395",
    "data-name": "Line 1395",
    y2: 18.531,
    transform: "translate(18428.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1398",
    "data-name": "Line 1398",
    y2: 18.531,
    transform: "translate(18446.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1401",
    "data-name": "Line 1401",
    y2: 18.531,
    transform: "translate(18465.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1367",
    "data-name": "Line 1367",
    y2: 18.531,
    transform: "translate(18252.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1375",
    "data-name": "Line 1375",
    y2: 18.531,
    transform: "translate(18307.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1384",
    "data-name": "Line 1384",
    y2: 18.531,
    transform: "translate(18361.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1393",
    "data-name": "Line 1393",
    y2: 18.531,
    transform: "translate(18416.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1396",
    "data-name": "Line 1396",
    y2: 18.531,
    transform: "translate(18434.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1399",
    "data-name": "Line 1399",
    y2: 18.531,
    transform: "translate(18452.5 -14570.365)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1445",
    "data-name": "Line 1445",
    y2: 54.851,
    transform: "translate(18210.5 -14590.378)",
    fill: "none",
    stroke: "#0e983e",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundTrack);
export default __webpack_public_path__ + "static/media/soundTrack.e150b74a6fa005e7c7a4fb8e450fe26d.svg";
export { ForwardRef as ReactComponent };